import { StepPage } from "features/subscription-process/navigation/Steps/StepPage";
import { NaturalPersonFormValues } from "features/new-actor/types/naturalPersonFormValues";
import { ActorForm } from "features/new-actor/components/ActorForm";
import { InsuredPersonSearchPage } from "./components/InsuredPersonSearchPage";
import { CenteredDashboardContent } from "features/dashboard/DashboardContent";
import { BranchCode } from "api/risk";
import { useActorRegistrationBySearchBar } from "./hooks/useActorRegistrationBySearchBar";
import { useTranslation } from "react-i18next";
import { NsKey } from "enums/NsKey";
import ActorRegistrationSummary from "./ActorRegistrationSummaryPage";

interface ActorRegistrationPageProps {
  branchCode: BranchCode;
}

export const ActorRegistrationPage = ({ branchCode }: ActorRegistrationPageProps) => {
  const {
    // State
    shouldShowSearchPage,

    // Data
    formConfig,
    editConfig,
    stepPageConfig,

    // Refs
    formikRef,

    // Handlers
    handleSubmit,
    handleShowAddForm,
    handleValidationChange,
    handleSelectPerson,
    searchBarConfig,
    registrationWording,
    currentLayout,
    shouldShowSummary
  } = useActorRegistrationBySearchBar(branchCode);
  const { t } = useTranslation(NsKey.ActorForm);

  if (shouldShowSummary) {
    return <ActorRegistrationSummary />
  }

  if (shouldShowSearchPage) {
    return <CenteredDashboardContent>
      <InsuredPersonSearchPage
        withNaturalPerson={searchBarConfig.withNaturalPerson}
        withLegalEntity={searchBarConfig.withLegalEntity}
        showAddForm={handleShowAddForm}
        handleSelectPerson={handleSelectPerson}
        title={t(registrationWording.searchTitle)}
        searchPlaceholder={registrationWording.searchPlaceholder}
        createLabel={t(registrationWording.createLabel)}
      />
    </CenteredDashboardContent>
  }

  return (
    <CenteredDashboardContent>
      <StepPage {...stepPageConfig}>
        <ActorForm<NaturalPersonFormValues>
          layoutVariant={currentLayout}
          titleKeys={registrationWording.formTitleKeys}
          formConfig={formConfig}
          formikRef={formikRef}
          editConfig={editConfig}
          onValidationChange={handleValidationChange}
          onSubmit={handleSubmit}
        />
      </StepPage>
    </CenteredDashboardContent>
  );
};
